(ns app.front.view.group.reporting.core
  (:require [core.front.carbon :as cc]
            [core.front.event :refer [>evt]]
            [re-frame.core-instrumented :as rf]
            [schema.core :as s]))


(rf/reg-event-fx ::redirect-to-default-report-page
  (fn [_ [_ group-id]]
    {:comm/command {:command    :group/reporting-data
                    :method     :get
                    :data       {:group-id group-id}
                    :on-success [::redirect-to-default-report-page.success]}}))


(rf/reg-event-fx ::redirect-to-default-report-page.success
  (fn [{:keys [db]} [_ _ {:keys [views]}]]
    {:route/push {:route  (first views)
                  :params (-> db :route/match :path-params)}}))

(defn view [_]
  (cc/loading-spinner))


(def route
  {:name        :view/group.reporting.base
   :view        view
   :parameters  {:path {:group-id s/Int}}
   :controllers [{:parameters {:path [:group-id]}
                  :start      (fn [params]
                                (let [group-id (-> params :path :group-id)]
                                  (>evt [::redirect-to-default-report-page group-id])))}]})
